import { IIcon } from '../../model/icon';

export const close: IIcon = {
  id: `CLOSE`,
  svg: `<path fill="#828282" d="M8 .8L7.2 0 4 3.2.8 0 0 .8 3.2 4 0 7.2l.8.8L4 4.8 7.2 8l.8-.8L4.8 4 8 .8z"/>`
};
